import { Module } from './module';

// recursively import all scripts and styles
const context = require.context('.', true, /\.(js|css|scss)$/);
context.keys().forEach(context);

module.exports = Module.name;



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/index.js